import { formatDateStringWithLocalTimeZone } from "@/lib/dates/formatters";
import { Box } from "@stenajs-webui/core";
import { FlatButton, stenaInfoCircle } from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import { replace } from "lodash";
import { InfoBoxItem } from "../InfoBoxItem";
import { MultiLegAgreementBox } from "../types";
import { IndentValues } from "@/lib/utils/IndentValues";
interface Props {
  mutliLegAgreement: MultiLegAgreementBox;
}

export const MultiLegAgreementInfoPairPopover: React.FC<Props> = ({
  mutliLegAgreement,
}) => {
  const formatUserName = (userName: string) => {
    const str = replace(userName, "LINE\\", "");
    return str.toUpperCase();
  };

  return (
    <Popover
      placement={"right"}
      disablePadding
      appendTo={document.body}
      trigger={"click"}
      renderTrigger={(props) => (
        <Box width={16}>
          <FlatButton leftIcon={stenaInfoCircle} {...props} />
        </Box>
      )}
    >
      <Box indent={IndentValues.SIXTEEN} spacing>
        <InfoBoxItem
          leftContent={"Name"}
          rightContent={mutliLegAgreement.name.toUpperCase()}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Cur."}
          rightContent={mutliLegAgreement.currency.code}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"No."}
          rightContent={mutliLegAgreement.idNumber ?? ""}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created"}
          rightContent={
            formatDateStringWithLocalTimeZone({
              dateString: mutliLegAgreement.dateCreated,
              options: {
                dateStyle: "short",
                timeStyle: "short",
              },
            }) ?? ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created by"}
          rightContent={
            mutliLegAgreement.createdBy
              ? formatUserName(mutliLegAgreement.createdBy)
              : ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified"}
          rightContent={
            (mutliLegAgreement.dateModified &&
              formatDateStringWithLocalTimeZone({
                dateString: mutliLegAgreement.dateModified,
                options: {
                  dateStyle: "short",
                  timeStyle: "short",
                },
              })) ??
            ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified by"}
          rightContent={
            mutliLegAgreement.modifiedBy
              ? formatUserName(mutliLegAgreement.modifiedBy)
              : ""
          }
          popoverEnabled
        />
      </Box>
    </Popover>
  );
};
